import React from 'react';
import { careers } from '../data/mock';
import { Link } from 'react-router-dom';
import { TrendingUp, Users, Award, Target, ArrowRight } from 'lucide-react';

const Career = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              Build a Meaningful Career in Healthcare Retail
            </h1>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '48px'
            }}>
              Join a fast-growing healthcare retailer. Pharmacists, store leaders, logistics, marketing & automation — apply now.
            </p>
            <Link to="/contact" className="btn-primary">
              Apply Now
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      {/* Why Work With Us */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            Why Choose Care Pharmacy
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '40px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <TrendingUp size={40} style={{ color: 'var(--brand-blue)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Growth Across Cities
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Expand your career with our rapid pan-India growth and emerging opportunities.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Users size={40} style={{ color: 'var(--brand-green)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Structured Training
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Comprehensive onboarding and continuous skill development programs.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Award size={40} style={{ color: 'var(--brand-blue)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Merit-Based Rewards
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Performance-driven incentives, recognition, and career advancement.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Target size={40} style={{ color: 'var(--brand-green)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                People-First Culture
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Inclusive workplace that values respect, collaboration, and work-life balance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Open Positions */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            Current Openings
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '24px'
          }}>
            {careers.map((job) => (
              <div key={job.id} className="hover-lift" style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px',
                border: '1px solid var(--border-light)'
              }}>
                <div style={{
                  display: 'inline-block',
                  padding: '6px 12px',
                  background: 'var(--bg-primary)',
                  marginBottom: '16px',
                  fontSize: '12px',
                  fontWeight: '500',
                  color: 'var(--brand-blue)'
                }}>
                  {job.department}
                </div>
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                  {job.title}
                </h3>
                <p className="body-regular" style={{
                  color: 'var(--text-secondary)',
                  marginBottom: '16px'
                }}>
                  {job.description}
                </p>
                <div style={{
                  paddingTop: '16px',
                  borderTop: '1px solid var(--border-light)'
                }}>
                  <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                    <strong>Locations:</strong> {job.locations.join(', ')}
                  </p>
                  <Link to="/contact" className="btn-icon">
                    Apply for this position
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            Employee Benefits
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '32px',
            maxWidth: '1000px',
            margin: '0 auto'
          }}>
            {[
              'Competitive salary packages',
              'Health insurance coverage',
              'Performance bonuses',
              'Career advancement opportunities',
              'Continuous learning programs',
              'Work-life balance initiatives',
              'Employee recognition awards',
              'Supportive team environment'
            ].map((benefit, index) => (
              <div key={index} style={{
                padding: '24px',
                background: 'var(--bg-primary)',
                borderRadius: '0px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px'
              }}>
                <div style={{
                  width: '8px',
                  height: '8px',
                  background: 'var(--brand-green)',
                  borderRadius: '50%',
                  marginTop: '6px',
                  flexShrink: 0
                }} />
                <span className="body-regular">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Application Process */}
      <section className="section-padding-small" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            How to Apply
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '32px',
            maxWidth: '1000px',
            margin: '0 auto'
          }}>
            {[
              { step: '01', title: 'Submit Application', description: 'Fill out the contact form with your resume and cover letter.' },
              { step: '02', title: 'Initial Screening', description: 'Our HR team reviews applications and shortlists candidates.' },
              { step: '03', title: 'Interview Process', description: 'Attend interviews with department heads and management.' },
              { step: '04', title: 'Join Our Team', description: 'Complete onboarding and begin your Care Pharmacy journey.' }
            ].map((process, index) => (
              <div key={index} style={{ textAlign: 'center' }}>
                <div style={{
                  fontSize: '48px',
                  fontWeight: '300',
                  color: 'var(--text-light)',
                  marginBottom: '16px'
                }}>
                  {process.step}
                </div>
                <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                  {process.title}
                </h3>
                <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  {process.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{
            maxWidth: '700px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              Ready to Make a Difference?
            </h2>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '32px'
            }}>
              Send your resume and join our mission to make quality healthcare accessible to all.
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn-primary">
                Apply Now
                <ArrowRight size={16} />
              </Link>
              <a href="mailto:info@carepharmacy.co" className="btn-secondary">
                Email Your Resume
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Career;